/**
 * The privacy notice, in the app rather than on a website, because the app
 * is where the data is and there is no separate site to point at.
 */
import { useNav } from '../App';
import { useT } from '../i18n/i18n';
import { Icons } from '../components/ui';
import { LACTATION_TEAM_URL, OFFICE_PHONE_DISPLAY, OFFICE_PHONE_TEL, PRACTICE_NAME } from '../lib/config';

export default function PrivacyScreen() {
  const t = useT();
  const nav = useNav();

  return (
    <div>
      <header className="sticky top-0 z-20 border-b border-line bg-bg/90 px-4 pt-3 pb-2.5 backdrop-blur">
        <div className="mx-auto flex max-w-lg items-center gap-2">
          <button
            type="button"
            onClick={() => nav.go('settings')}
            aria-label={t.common.actions.back}
            className="-ml-2 rounded-full p-2 text-ink-soft hover:bg-surface-2"
          >
            {Icons.chevronRight('h-6 w-6 rotate-180')}
          </button>
          <div className="min-w-0">
            <h1 className="truncate text-xl leading-tight">{t.privacy.title}</h1>
            <p className="truncate text-sm text-ink-soft">{t.privacy.updated}</p>
          </div>
        </div>
      </header>

      <div className="px-4 py-4">
        <PrivacyBody />
      </div>
    </div>
  );
}

/** The notice itself, shared by the screen and the onboarding sheet. */
export function PrivacyBody() {
  const t = useT();
  return (
    <div className="space-y-4">
        <section className="card border-primary/30 p-5">
          <h2 className="text-base text-primary">{t.privacy.summary.title}</h2>
          <ul className="mt-2 space-y-2">
            {t.privacy.summary.points.map((point) => (
              <li key={point} className="flex items-start gap-2 text-sm leading-relaxed">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mt-0.5 h-4 w-4 shrink-0 text-good"
                  aria-hidden="true"
                >
                  <path d="m5 12.5 4.5 4.5L19 7.5" />
                </svg>
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>

        {t.privacy.sections.map((section) => (
          <section key={section.title} className="card p-5">
            <h2 className="text-base">{section.title}</h2>
            <p className="mt-1.5 text-sm leading-relaxed text-ink-soft">{section.body}</p>
          </section>
        ))}

        <section className="card p-5">
          <h2 className="text-base">{PRACTICE_NAME}</h2>
          <a
            href={`tel:${OFFICE_PHONE_TEL}`}
            className="mt-2 inline-flex min-h-[44px] items-center gap-2 font-bold text-primary"
          >
            {Icons.phone('h-5 w-5')}
            {OFFICE_PHONE_DISPLAY}
          </a>
          <a
            href={LACTATION_TEAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-sm font-bold text-accent underline"
          >
            {LACTATION_TEAM_URL.replace('https://', '')}
          </a>
        </section>
    </div>
  );
}
